goog.provide("shadow.js.shim.module$src$svg$devices$server_network_svg$default");
shadow.js.shim.module$src$svg$devices$server_network_svg$default = shadow.js.shim.module$src$svg$devices$server_network_svg.default;
